import keyMirror from 'src/utilities/keyMirror';

export const ACTION_TYPES = keyMirror({
  MULTI_APPROVAL_FETCH: null,
  MULTI_APPROVAL_FETCH_SUCCESS: null,
  MULTI_APPROVAL_FETCH_FAILED: null,

  MULTI_APPROVAL_SUBMIT: null,
  MULTI_APPROVAL_SUBMIT_SUCCESS: null,
  MULTI_APPROVAL_SUBMIT_FAILED: null,

  CHILD_MULTI_APPROVAL_FETCH: null,
  CHILD_MULTI_APPROVAL_FETCH_SUCCESS: null,
  CHILD_MULTI_APPROVAL_FETCH_FAILED: null,

  CHILD_MULTI_APPROVAL_SUBMIT: null,
  CHILD_MULTI_APPROVAL_SUBMIT_SUCCESS: null,
  CHILD_MULTI_APPROVAL_SUBMIT_FAILED: null,

  CHILD_MULTI_APPROVAL_ACTIVE_FETCH: null,
  CHILD_MULTI_APPROVAL_ACTIVE_FETCH_SUCCESS: null,
  CHILD_MULTI_APPROVAL_ACTIVE_FETCH_FAILED: null,

  ACTIVE_MULTI_APPROVAL_FETCH: null,
  ACTIVE_MULTI_APPROVAL_FETCH_SUCCESS: null,
  ACTIVE_MULTI_APPROVAL_FETCH_FAILED: null,
});
